import { generateQuestionURL } from './generateQuestionURL';

export function generateQuestionsByStudentsURL(activityInstanceId: number) {
  const url = generateQuestionURL();
  url.pathname += `${activityInstanceId}/students`;
  return url;
}
